import { Box, Typography } from "@mui/material";
import CustomInputLabel from "../../../../../components/CustomInputLabel";
import CustomInput from "../../../../../components/CustomInput";
import CustomButton from "../../../../../components/CustomButton";
import ArrowLeftCircle from "../../../../../../media/images/icons/arrow-left-circle";

export default function ResidenceInfo() {
  return (
    <Box
      sx={{
        marginTop: "16px",
        width: "100%",
        backgroundColor: "background.default",
        padding: "16px",
        borderRadius: "16px",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontWeight: "600",
          color: "secondary.dark",
          fontSize: "16px",
        }}
      >
        ثبت مشخصات محل سکونت{" "}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginTop: "16px",
        }}
      >
        <Box>
          <CustomInputLabel required>{"استان محل سکونت"}</CustomInputLabel>
          {/* <CustomAutoComple
            placHolder="استان محل سکونت را انتخاب کنید"
            options={provinces}
          /> */}
        </Box>
        <Box>
          <CustomInputLabel required>{"شهر محل سکونت"}</CustomInputLabel>
          {/* <CustomAutoComple
            placHolder="شهر محل سکونت را انتخاب کنید"
            options={provinces}
          /> */}
        </Box>
        <Box>
          <CustomInputLabel>{"کدپستی"}</CustomInputLabel>
          <CustomInput placHolder="کد پستی محل سکونت را وارد کنید..." />
        </Box>

        <Box>
          <CustomInputLabel>{"آدرس محل سکونت"}</CustomInputLabel>
          <CustomInput
            textArea
            placHolder="آدرس شرکت را این قسمت وارد کنید..."
          />
        </Box>

        <CustomButton
          // loading={loading}
          // onClick={formik.handleSubmit}
          flexDirection="row"
          title="تکمیل مرحله و ادامه"
          justifyContent="center"
          bgColor="secondary.main"
          width="100%"
          fSize="16px"
          px="10px"
          py="10px"
          borderRadius="10px"
          icon2={<ArrowLeftCircle size={32} />}
          mt="16px"
        />
      </Box>
    </Box>
  );
}
